import { render, staticRenderFns } from "./data-center-card.vue?vue&type=template&id=c444b1c0&scoped=true"
import script from "./data-center-card.vue?vue&type=script&lang=js"
export * from "./data-center-card.vue?vue&type=script&lang=js"
import style0 from "./data-center-card.vue?vue&type=style&index=0&id=c444b1c0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c444b1c0",
  null
  
)

export default component.exports